<template>
  <layout-checkout>
    <template slot="body">
      <div class="PaB-order-processing" v-if="cart.checkoutStatus && cart.checkoutStatus === 'processing'">
        <h2>Order Processing</h2>
        <p>Processing your order</p>
      </div>

      <div class="PaB-order-success"
        v-if="cart.checkoutStatus && cart.checkoutStatus === 'success' && cart.order_type === 'pickup'">
        <h2>Order has been placed!</h2>
        <p>Thank you for shopping with {{venueInfo.name}}! Your order will be ready for pick up at our store location.
        </p>
        <div class="PaB-cart-items">
          <cart-item v-for="cartItem in cartItems" :key="cartItem.product_id" :cartItem="cartItem"></cart-item>
        </div>
        <order-summary :items="cartItems"></order-summary>
      </div>

      <div class="PaB-order-success"
        v-if="cart.checkoutStatus && cart.checkoutStatus === 'success' && cart.order_type === 'kiosk'">
        <h2>Order has been placed!</h2>
        <p>Thank you for shopping with {{venueInfo.name}}! Your name will be called when your order is ready.
        </p>
        <div class="PaB-cart-items">
          <cart-item v-for="cartItem in cartItems" :key="cartItem.product_id" :cartItem="cartItem"></cart-item>
        </div>
        <order-summary :items="cartItems"></order-summary>
      </div>

      <div class="PaB-order-success"
        v-if="cart.checkoutStatus && cart.checkoutStatus === 'success' && cart.order_type === 'delivery'">
        <h2>Order has been placed!</h2>
        <p>Thank you for shopping with {{venueInfo.name}}! You will receive a text alert when your order is about to be
          sent out for delivery.</p>
        <div class="PaB-cart-items">
          <cart-item v-for="cartItem in cartItems" :key="cartItem.product_id" :cartItem="cartItem"></cart-item>
        </div>
        <order-summary :items="cartItems"></order-summary>
      </div>

      <div class="PaB-order-errors" v-if="cart.checkoutStatus && cart.checkoutStatus.includes('error')">
        <h2>Order Error</h2>

        <ul>
          <li v-for="error in cart.checkoutErrors" :key="error">{{ error }}</li>
        </ul>

        <app-button type="secondary" :block="true" label="Back to cart" @click.native="backToCart"></app-button>
      </div>
    </template>
    <template slot="actions">
      <company-info v-if="!isKiosk"></company-info>
      <div class="PaB-button-group" v-if="!isKiosk">
        <a v-if="venueInfo.phone" :href="`tel:${venueInfo.phone.replace(/\D/g, '')}`"
          class="PaB-button PaB-button--block PaB-button--secondary">Call
          {{venueInfo.phone}}</a>
        <a v-if="venueInfo.address" :href="`https://www.google.com/maps/place/${encodeURIComponent(venueInfo.address)}`"
          target="_blank" rel="noopener" class="PaB-button PaB-button--block PaB-button--secondary">Get Directions</a>
      </div>
      <div class="PaB-button-group" v-else>
        <app-button type="secondary" :block="true" label="Close" @click.native="close"></app-button>
      </div>
      <v-idle v-if="cart.checkoutStatus && cart.checkoutStatus === 'success'" @idle="close" :duration="100"
        style="display: none;" />
    </template>
  </layout-checkout>
</template>

<style lang="scss" scoped>
.PaB-company-info {
  margin: 20px;
}
.PaB-cart-items {
  margin-bottom: 20px;
}
</style>

<script>
import LayoutCheckout from '@/components/LayoutCheckout'
import OrderSummary from '@/components/OrderSummary'
import AppButton from '@/components/AppButton'
import CartItem from '@/components/CartItem'
import CompanyInfo from '@/components/CompanyInfo'

export default {
  components: {
    LayoutCheckout,
    OrderSummary,
    AppButton,
    CartItem,
    CompanyInfo
  },
  computed: {
    cart () {
      return this.$store.state.cart
    },
    cartItems () {
      return this.cart.ordered_items
    },
    venueInfo () {
      return this.$store.state.venue.info
    }
  },
  created () {
    // Back to cart if no items
    if (this.cart.order_items_attributes.length === 0) {
      this.backToCart()
    }
  },
  methods: {
    isKiosk () {
      return !!this.widgetOptions.config.kiosk_mode
    },
    close () {
      // if (this.isKiosk()) {
      //   this.$store.dispatch('products/getAllProducts')
      // }
      // this.$router.push('/')
      if (this.isPaymentKiosk()) {
        window.location.href = 'https://www.bcpurchase.com/kiosk-landing-page'
      } else {
        this.$store.dispatch('products/getAllProducts')
        this.$router.push('/')
      }
    },
    isPaymentKiosk () {
      if (typeof Android !== 'undefined') {
        // eslint-disable-next-line
        return Android.isPaymentKiosk() && this.isKiosk()
      } else {
        return false
      }
    },
    backToCart (e) {
      if (e) {
        e.preventDefault()
      }
      const currentRoute = this.$router.currentRoute.fullPath
      const routeParts = currentRoute.split('/order')
      if (!routeParts[0]) {
        this.$router.push('/')
      } else {
        this.$router.push(`${routeParts[0]}`)
      }
    }
  }
}
</script>
